<mat-nav-list style="max-height: 1200px; padding: 0;" class="primary-menu" *ngIf="entry">
  <mat-list-item
    *ngIf="entry.config.link"
    (click)="handleEntryClick()"
    [matTooltip]="entry.config.name"
    matTooltipPosition="right"
    [routerLink]="entry.config.link"
    routerLinkActive="active"
  >
    <div style="color: white; width: 100%" class="{{ iconOnly ? 'flex-center' : 'flex-start-center' }}" [ngStyle]="{ padding: iconOnly ? '1rem 0' : 0 }">
      <mat-icon matListIcon iconsmall *ngIf="entry.config.icon">{{ entry.config.icon }} </mat-icon>
      <h3 matLine *ngIf="!iconOnly" style="padding-left: 1rem; margin-bottom: 0">{{ entry.config.name }}</h3>
    </div>
  </mat-list-item>
</mat-nav-list>
